import { render, staticRenderFns } from "./ProductPurchasedModal.vue?vue&type=template&id=6c171b96&scoped=true"
import script from "./ProductPurchasedModal.vue?vue&type=script&lang=js"
export * from "./ProductPurchasedModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPurchasedModal.vue?vue&type=style&index=0&id=6c171b96&prod&lang=scss"
import style1 from "./ProductPurchasedModal.vue?vue&type=style&index=1&id=6c171b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c171b96",
  null
  
)

export default component.exports